// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PAddTeamOutlinedSvg from "@fishx/icons-svg/es/asn/PAddTeamOutlined";
import FishxIcon from '../components/FishxIcon';

var PAddTeamOutlined = function PAddTeamOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PAddTeamOutlinedSvg
  }));
};

PAddTeamOutlined.displayName = 'PAddTeamOutlined';
export default React.forwardRef(PAddTeamOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PAddTeamOutlined.js
// module id = 3196
// module chunks = 0